const messageType = {

  ERROR_CODE            : 0,
  UPDATE_STATE          : 1,
  BUILD_LBVH            : 5,
  BUILD_OCTREE          : 6,
  GET_OCTREE            : 7,
  BUILD_HALF_EDGES      : 8,
  GET_HALF_EDGES        : 9,
  PARSE_CORTO           : 10,
  GET_GEOMETRY_CORTO    : 11,
  INIT_ZSTD             : 12,
  PARSE_ZSTD            : 13,
  GET_GEOMETRY_ZSTD     : 14,
  ENCODE_ZSTD           : 15,
  BUILD_NORMALS         : 16,
  BUILD_BORDER          : 17,
  BUILD_NORMALS_AND_BORDER  : 18,
  GET_NORMALS           : 19,
  RECALCULATE_BOUNDINGS : 20,
  GET_MINMAX            : 21,
  TERMINATE             : 22,
  INVERT_NORMALS        : 23,
  GET_INVERTED_NORMALS  : 24,
  INIT_WASM             : 25,
  HORN_ALIGN            : 26,
  ICP_ALIGN             : 27,
  BAKE_DM               : 28,
  INIT_PLY              : 29,
  PARSE_PLY             : 30,
  START_OBJ             : 31,
  PARSE_OBJ             : 32,
  FINISH_OBJ            : 33,
  INIT_STL              : 34,
  PARSE_STL             : 35,
  INIT_USD              : 36,
  PARSE_USD             : 37,
};

const resultStatus = {

  ALL_OK                    : 0,
  UNKNOWN_MESSAGE_TYPE      : 1,
  PARSING_ERROR             : 2,
  OCTREE_BUILDING_ERROR     : 3,
  HALF_EDGES_BUILDING_ERROR : 4,
  TERMINATED                : 5,
  MODULE_UNINITIALIZED      : 6,

};

const workerTypes = {

  CORTO_PARSER        : 1,
  ZSTD_PARSER         : 2,
  GEOMETRY_PROCESSOR  : 3,
  WASM_PROCESSOR      : 4,
  PLY_PARSER          : 5,
  OBJ_PARSER          : 6,
  STL_PARSER          : 7,
  USD_PARSER          : 8,

};

function getWorkerType(type) {

  switch(type) {
    case messageType.PARSE_CORTO:
    case messageType.GET_GEOMETRY_CORTO:
      return workerTypes.CORTO_PARSER;
    case messageType.INIT_ZSTD:
    case messageType.PARSE_ZSTD:
    case messageType.ENCODE_ZSTD:
    case messageType.GET_GEOMETRY_ZSTD:
      return workerTypes.ZSTD_PARSER;
    case messageType.BUILD_OCTREE:
    case messageType.GET_OCTREE:
    case messageType.BUILD_HALF_EDGES:
    case messageType.GET_HALF_EDGES:
    case messageType.BUILD_LBVH:
    case messageType.BUILD_NORMALS:
    case messageType.BUILD_BORDER:
    case messageType.BUILD_NORMALS_AND_BORDER:
    case messageType.INVERT_NORMALS:
    case messageType.RECALCULATE_BOUNDINGS:
    case messageType.GET_MINMAX:
      return workerTypes.GEOMETRY_PROCESSOR;
    case messageType.INIT_WASM:
    case messageType.HORN_ALIGN:
    case messageType.ICP_ALIGN:
    case messageType.BAKE_DM:
      return workerTypes.WASM_PROCESSOR;
    case messageType.INIT_PLY:
    case messageType.PARSE_PLY:
      return workerTypes.PLY_PARSER;
    case messageType.START_OBJ:
    case messageType.PARSE_OBJ:
    case messageType.FINISH_OBJ:
      return workerTypes.OBJ_PARSER;
    case messageType.INIT_STL:
    case messageType.PARSE_STL:
      return workerTypes.STL_PARSER;
    case messageType.INIT_USD:
    case messageType.PARSE_USD:
      return workerTypes.USD_PARSER;
    default:
      throw "Unsupported task type: " + type;
  }

}

export { messageType, resultStatus, workerTypes, getWorkerType };
